export const ScanSummaryComponent = {
  bindings: {
    answers: '<',
  },
  templateUrl: 'missions/components/Scans/scan-summary/scan-summary.html',
  controller: function ScanSummaryController(
    $translate,
    SF_PRODUCT_ANSWER_TYPES
  ) {
    'ngInject';
    const UNRECOGNIZED_CATALOG_KEY = 'unrecognized_catalog';

    this.$onInit = () => {
      const catalogsSummary = this.answers
        .filter((a) =>
          [
            SF_PRODUCT_ANSWER_TYPES.SALES,
            SF_PRODUCT_ANSWER_TYPES.COUNT,
          ].includes(a.type)
        )
        .reduce((summary, answer) => {
          const catalogKey =
            answer.metadata.catalog_id || UNRECOGNIZED_CATALOG_KEY;

          if (!summary[catalogKey]) {
            summary[catalogKey] = {
              name:
                answer.metadata.catalog_name ||
                $translate.instant('SCAN_SUMMARY_UNRECOGNIZED_CATALOG'),
              units: {},
            };
          }

          if (answer.type === SF_PRODUCT_ANSWER_TYPES.SALES) {
            return this.computeSalesSummary(
              answer,
              summary,
              catalogKey,
              answer.metadata.sellTotalPrice,
              answer.values[1].value
            );
          }

          if (answer.type === SF_PRODUCT_ANSWER_TYPES.COUNT) {
            return this.computeCountSummary(
              summary,
              catalogKey,
              answer.values[1].value
            );
          }

          return summary;
        }, {});
      this.catalogsSummary = Object.values(catalogsSummary).map((catalog) => {
        return {
          ...catalog,
          units: Object.values(catalog.units),
        };
      });
    };

    this.computeSalesSummary = (answer, summary, catalogKey, value, count) => {
      const unit = this.getFieldUnit(answer);
      if (!summary[catalogKey].units[unit]) {
        summary = {
          ...summary,
          [catalogKey]: {
            ...summary[catalogKey],
            units: {
              ...summary[catalogKey].units,
              [unit]: {
                unit: unit,
                sales: value,
                count: count,
              },
            },
          },
        };
        return summary;
      }
      summary[catalogKey].units[unit].sales += value;
      summary[catalogKey].units[unit].count += count;
      return summary;
    };

    this.computeCountSummary = (summary, catalogKey, value) => {
      if (!summary[catalogKey].count) {
        summary[catalogKey].count = value;
        return summary;
      }
      summary[catalogKey].count += value;
      return summary;
    };

    this.isNumber = (value) => typeof value === 'number';

    this.getFieldUnit = (answer) => answer.values[3].value;
  },
};
